'use client';
import{createContext}from"react";var EditorContext=createContext(null);export{EditorContext};
